import React from 'react';
import styles from './index.module.scss';
import DynamicFavicon from '../../../img_components/dynamic_favicon';

const HeaderLogoBlock = ({ blockData, path_to_folder }) => {
  const content = blockData?.block_content;
  if (!content || !Array.isArray(content)) return null;

  const logoContent = content[0];
  const processedImgName =
    logoContent?.img_name && logoContent.img_name !== 'none'
      ? logoContent.img_name.includes('\\')
        ? logoContent.img_name.substring(logoContent.img_name.lastIndexOf('\\') + 1)
        : logoContent.img_name
      : null;
  const logoImageUrl = processedImgName ? path_to_folder + processedImgName : null;
  const siteName = logoContent?.content_text || 'Сайт';

  return (
    <div className={styles.headerLogoBlock}>
      {logoImageUrl && <DynamicFavicon logoImageUrl={logoImageUrl} />}
      <div className={styles.contentContainer}>
        {processedImgName && (
          <img
            src={path_to_folder + processedImgName}
            alt={siteName || 'Логотип'}
            className={styles.logoImage}
          />
        )}
        {siteName && <span className={styles.siteName}>{siteName}</span>}
      </div>
    </div>
  );
};

export default HeaderLogoBlock;
